import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useApi } from '../hooks'
import { AlertNotified, AlertQuery, PrometheusAlert } from '../types'

const api = useApi('/v2')

export async function getAlerts(
  query: AlertQuery = {},
  config?: AxiosRequestConfig
): Promise<PrometheusAlert[]> {
  const response = await api.get('/alerts', {
    ...config,
    params: query
  })

  return response.data
}

export async function getAlertNotified(
  device: string,
  config?: AxiosRequestConfig
): Promise<AlertNotified> {
  const response: AxiosResponse<AlertNotified> = await api.get(
    `/alerts/notified?device=${device}`,
    config
  )

  return response.data
}
